import {LockerIcon, PickupPointsIcon, RussianPostIcon, SortCenterIcon} from '@yandex-delivery/blocks'

import {isPostOffice} from '../utils/is-post-office'
import {isTerminal} from '../utils/is-terminal'
import {isWarehouse} from '../utils/is-warehouse'
import type {Props} from './types'

export function PointIcon(props: Props) {
  const {point, className} = props

  if (isPostOffice(point?._type)) {
    return <RussianPostIcon className={className} />
  }

  if (isTerminal(point?._type)) {
    return <LockerIcon className={className} />
  }

  if (isWarehouse(point?._type)) {
    return <SortCenterIcon className={className} />
  }

  return <PickupPointsIcon className={className} />
}
